












































































































































import { Component, Vue, Watch, Emit } from "vue-property-decorator";
import locationService, { LocationService } from "../services/LocationService";
var _ = require("underscore")._;

@Component
export default class LocationForm extends Vue {
  private location: any = {
    name: "",
    address: "",
    latitude: "",
    longitude: "",
    telephone: "",
    status: "A",
    time: [
      { day: 0, startTime: null, endTime: null },
      { day: 1, startTime: null, endTime: null },
      { day: 2, startTime: null, endTime: null },
      { day: 3, startTime: null, endTime: null },
      { day: 4, startTime: null, endTime: null }
    ]
  };
  private dayType: any = [
    "จันทร์ - ศุกร์",
    "เสาร์",
    "อาทิตย์",
    "วันหยุดนักขัตฤกษ์",
    "วันหยุดชดเชย"
  ];
  private dayClose: any = [false, false, false, false, false];
  private status: any = [
    { text: "Active", value: "A" },
    { text: "Inactive", value: "I" }
  ];
  private title: string = "Create Location";
  private isCreate: boolean = true;

  created() {
    if (this.$router.currentRoute.params.id !== "create") {
      this.title = "Location Detail";
      this.isCreate = false;
      this.getLocation();
    }
  }

  toggleClose(close: any, time: any) {
    if (!close) {
      time.startTime = null;
      time.endTime = null;
    }
  }

  getLocation() {
    locationService
      .getLocation(this.$router.currentRoute.params.id)
      .then((response: any) => {
        this.location = response.data;
        this.location.time = _.sortBy(this.location.time, "day");
        _.each(this.location.time, (time: any) => {
          if (time.startTime === null && time.endTime === null) {
            this.dayClose[time.day] = true;
          }
        });
      });
  }

  updateLocation(location: any) {
    this.$swal({
      title: "Waiting",
      timer: 10000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        this.$swal.showLoading();
      }
    });
    locationService
      .saveLocation(location)
      .then(response => {
        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Complete",
          type: "success",
          onClose: () => {
            this.$router.push({ name: "location" });
          }
        });
      })
      .catch(error => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }

  createLocation(location: any) {
    this.$swal({
      title: "Waiting",
      timer: 10000,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        this.$swal.showLoading();
      }
    });
    locationService
      .createLocation(location)
      .then(response => {
        this.$swal({
          confirmButtonColor: "#28a745",
          title: "Complete",
          type: "success",
          onClose: () => {
            this.$router.push({ name: "location" });
          }
        });
      })
      .catch(error => {
        this.$swal({
          title: "Please try again!",
          type: "error"
        });
      });
  }
}
